const customSwiper = {
	thumbs: null,
	classes: {
		swiper_thumbs: 'custom-swiper-thumbs',
		swiper: "custom-swiper",
	},
	is: (swiper, classname) => {
		return $(swiper.el).hasClass(classname);
	},
};
const sections = {
	video: "video-section",
};

function initNewSwiper(swiper_selector, thumbs_of_swiper = null) {
	/*
    swiper_selector -> to prevent conflicts it is better to use id
    the swipe settings could be assigned in html with data attributes to the swiper_selector
    if something is not set - it gets a default val
    feel free to bring more stuff :)
    
    thumbs_of_swiper -> when slider has thumbs: the function is called like initBangSwiper('thumbs-slider', 'main-slider')
      after the thumbs-slider is initialized, it will call automaticaly init of the main-slider
  */
	var swiper_element = $(swiper_selector);
	var effect = swiper_element.data("effect") ? $(swiper_element).data("effect") : "slide";

	//speed and autoplayDelay can accept value 0
	var speed = typeof swiper_element.data("speed") != "undefined" ? $(swiper_element).data("speed") : 3000;

	/*set data-autoplay="false" to disable autoplay; any other value in ms like 1000 2000 will activate the autoplay*/
	var autoplayDelay = typeof swiper_element.data("autoplay") != "undefined" ? $(swiper_element).data("autoplay") : 1000;
	var autoplayMobile = typeof swiper_element.data("autoplay-mobile") != "undefined" ? $(swiper_element).data("autoplay-mobile") : 5000;

	var autoplayMobileSettings = false;

	if (autoplayMobile) {
		var autoplayMobileSettings = {
			delay: autoplayMobile,
			disableOnInteraction: false,
		};
	}

	var autoplaySubSettings = false;
	if (autoplayDelay) {
		var autoplaySubSettings = {
			delay: autoplayDelay,
			disableOnInteraction: false,
		};
	}

	var loop = swiper_element.data("loop") === true;

	var perViewMobile = swiper_element.data("per-view-mobile") ? $(swiper_element).data("per-view-mobile") : 1;
	var perViewTablet = swiper_element.data("per-view-tablet") ? $(swiper_element).data("per-view-tablet") : 1;
	var perViewTablet__big = swiper_element.data("per-view-tablet-big") ? $(swiper_element).data("per-view-tablet-big") : false;
	var perViewDesktop = swiper_element.data("per-view-desktop") ? $(swiper_element).data("per-view-desktop") : 1;

	var betweenMobile = swiper_element.data("between-mobile") ? $(swiper_element).data("between-mobile") : 15;
	var betweenTablet = swiper_element.data("between-tablet") ? $(swiper_element).data("between-tablet") : 15;
	var betweenDesktop = swiper_element.data("between-desktop") ? $(swiper_element).data("between-desktop") : 15;

	var initialSlideMobile = swiper_element.data("initial-slide-mobile") ? $(swiper_element).data("initial-slide-mobile") : 0;
	var initialSlideTablet = swiper_element.data("initial-slide-tablet") ? $(swiper_element).data("initial-slide-tablet") : 0;

	var mobile_centered = swiper_element.data("mobile-centered") ? $(swiper_element).data("mobile-centered") : false;
	var tablet_centered = swiper_element.data("tablet-centered") ? $(swiper_element).data("tablet-centered") : false;
	var desktop_centered = swiper_element.data("desktop-centered") ? $(swiper_element).data("desktop-centered") : false;

	var custom_pagination = swiper_element.data("custom-pagination") ? $(swiper_element).data("custom-pagination") : false;

	var mobile_disabled = swiper_element.data("mobile-disabled") ? false : true;
	var tablet_disabled = swiper_element.data("tablet-disabled") ? false : true;
	var desktop_disabled = swiper_element.data("desktop-disabled") ? false : true;

	var slider_direction = swiper_element.data("slider-direction") ? $(swiper_element).data("slider-direction") : "horizontal";
	var slider_use_pagination_count = swiper_element.data("slider-use-pagination-count") ? $(swiper_element).data("slider-use-pagination-count") : "bullets";



	var navigationSubSettings = false;

	var thumbSettings = thumbs_of_swiper !== null && {
		slideToClickedSlide: true,
		centeredSlides: true,
		threshold: 2,
		noSwipingClass: 'swiper-slide',
		noSwiping: true,
	}

	var swiper_f = new Swiper(swiper_selector, {
		effect: effect,
		slidesPerView: perViewMobile,
		spaceBetween: betweenMobile,
		loop: loop,
		speed: speed,
		freeMode: {
			enabled: false,
			momentumRatio: 0.2,
			momentumBounce: false,
			momentumVelocityRatio: 1,
			sticky: true,
		},
		noSwipingClass: "disabled",
		noSwiping: true,
		...thumbSettings,
		mousewheel: false,
		direction: slider_direction,
		observer: true,
		observerUpdate: true,
		observeSlideChildren: true,
		autoplay: {
			delay: 2500,
			disableOnInteraction: false,
		  },
		scrollbar: {
			//el: '.swiper-scrollbar',
			draggable: true,
		},
		pagination: {
			el: swiper_selector + " .swiper-pagination",
			clickable: true,
			type: slider_use_pagination_count
		},
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		breakpoints: {
			320: {
				spaceBetween: betweenMobile,
				autoplay: autoplayMobileSettings,
				centeredSlides: mobile_centered,
				initialSlide: initialSlideMobile,
				enabled: mobile_disabled,
			},
			750: {
				/*750 and up to next*/
				slidesPerView: perViewTablet,
				spaceBetween: betweenTablet,
				autoplay: autoplayMobileSettings,
				centeredSlides: tablet_centered,
				initialSlide: initialSlideTablet,
				enabled: tablet_disabled,
			},
			989: {
				/*990 and up to next*/
				slidesPerView: perViewTablet__big ? perViewTablet__big : perViewDesktop,
				spaceBetween: betweenDesktop,
				centeredSlides: desktop_centered,
				enabled: desktop_disabled,
			},
			1080: {
				centeredSlides: desktop_centered,
				slidesPerView: perViewDesktop,
				spaceBetween: betweenDesktop,
				autoplay: autoplaySubSettings,
				enabled: desktop_disabled,
			},
		},
		thumbs: {
			swiper: thumbs_of_swiper,
		},
		navigation: navigationSubSettings,
		on: {
			slideChangeTransitionStart: function(swiper) {
				if (navigationSubSettings) {
					if (!$(`${swiper_selector} .swiper-slide:first`).hasClass("swiper-slide-active")) {
						$(navigationSubSettings.prevEl).fadeIn();
					}
					if (!swiper.isEnd) {
						$(navigationSubSettings.nextEl).fadeIn();
					}
				}
			},
			init: function() {
				if (swiper_element.hasClass('gallery_slider_holder')) {
					var text = swiper_element.find('.swiper-slide-active .gallery__heading span').text();
					$('.gallery-text').text(text)
				}
			},
			slideChangeTransitionEnd: function() {
				if (swiper_element.hasClass('gallery_slider_holder')) {
					var text = swiper_element.find('.swiper-slide-active .gallery__heading span').text();
					$('.gallery-text').text(text)
				}
			},
			reachBeginning: function() {
				$(navigationSubSettings.prevEl).fadeOut();
			},
			reachEnd: function() {
				$(navigationSubSettings.nextEl).fadeOut();
			},
		},
	});

	swiper_f.init();

	$(".swiper-button-next").on("click", function() {
		var section = $(this).data("for-section");
		if (section && swiper_selector == "#" + section) {
			swiper_f.slideNext();
		}
	});

	$(".swiper-button-prev").on("click", function() {
		var section = $(this).data("for-section");
		if (section && swiper_selector == "#" + section) {
			swiper_f.slidePrev();
		}
	});

	if (swiper_element.data("thumbs-to")) {
		customSwiper.thumbs = initNewSwiper(swiper_element.data("thumbs-to"), swiper_f);
	}

	swiper_f.on('slideChangeTransitionEnd', function(swiper) {
		const isPDPSlider = customSwiper.is(swiper, 'product_slider');
		if (isPDPSlider) {
			customSwiper.thumbs != null && customSwiper.thumbs.slideTo(swiper.activeIndex, 0, false) && customSwiper.thumbs.update();
		}
	});


	return swiper_f;
}

$(document).ready(function() {
	$(`.${customSwiper.classes.swiper}`).each(function() {
		initNewSwiper('#' + $(this).attr('id'));
	});
	$(`.${customSwiper.classes.swiper_thumbs}`).each(function() {
		initNewSwiper('#' + $(this).attr('id'));
	});

	customSwiper?.thumbs?.thumbs?.swiper.on('touchStart', function(swiper, event) {
		const slideIndex = $(event?.path?.[0]).closest('.swiper-slide').index();
		customSwiper.thumbs.slideTo(slideIndex, 0, false) && customSwiper.thumbs.update();
	});
})
    
    // Taken from the original site for the Cookie Bar 
function GetCookie(name) {
  var arg=name+"=";
  var alen=arg.length;
  var clen=document.cookie.length;
  var i=0;
  while (i<clen) {
	var j=i+alen;
	if (document.cookie.substring(i,j)==arg)
	  return "here";
	i=document.cookie.indexOf(" ",i)+1;
	if (i==0) break;
  }
  return null;
}
function testFirstCookie(){
	var offset = new Date().getTimezoneOffset();
	if ((offset >= -180) && (offset <= 0)) { // European time zones
		var visit=GetCookie("cookieCompliancyAccepted");
		if (visit==null){
		   $("#myCookieConsent").delay(500).fadeIn(750);	// Show warning
	   } else {
			$("#myCookieConsent").hide();
	   }		
	}
}
$(document).ready(function(){
    $("#cookieButton").on( "click", function() {
		var expire=new Date();
		expire=new Date(expire.getTime()+7776000000);
		document.cookie="cookieCompliancyAccepted=here; expires="+expire+";path=/";
        $("#myCookieConsent").fadeOut(175);
    });
	testFirstCookie();
});

// cookie stuff
function setCookie(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	var expires = "expires=" + d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function checkACookieExists(cname) {
	if (document.cookie.split(";").some((item) => item.trim().startsWith(cname + "="))) {
		return true;
	}

	return false;
}